export const GET_CS_PARAMS = 'GET_CS_PARAMS'
export const SET_CS_PARAM = 'SET_CS_PARAM'
export const CREATE_CS_PARAM = 'CREATE_CS_PARAM'
export const REMOVE_CS_PARAM = 'REMOVE_CS_PARAM'
export const UPDATE_CS_PARAM = 'UPDATE_CS_PARAM'
export const SET_CS_PARAM_OFFSET_LIMIT = 'SET_CS_PARAM_OFFSET_LIMIT'
export const SET_CS_PARAM_ERROR = 'SET_CS_PARAM_ERROR'
export const CLEAR_CS_PARAM_ERROR = 'CLEAR_CS_PARAM_ERROR'
export const PROCESS_REINDEX = 'PROCESS_REINDEX'

export function setError (err) {
  return {
    type: SET_CS_PARAM_ERROR,
    payload: { err },
  }
}

export function clearError () {
  return {
    type: CLEAR_CS_PARAM_ERROR,
    payload: {},
  }
}

export function getCSParams ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: GET_CS_PARAMS,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function setCSParam ({
  storeKey, data, total, processing = false,
}) {
  return {
    type: SET_CS_PARAM,
    payload: {
      storeKey, data, total, processing,
    },
  }
}

export function createCSParam ({ storeKey, data }) {
  return {
    type: CREATE_CS_PARAM,
    payload: { storeKey, data },
  }
}

export function updateCSParam ({ storeKey, data }) {
  return {
    type: UPDATE_CS_PARAM,
    payload: { storeKey, data },
  }
}

export function removeCSParam ({ storeKey, id }) {
  return {
    type: REMOVE_CS_PARAM,
    payload: { storeKey, id },
  }
}

export function setCSParamOffsetLimit ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: SET_CS_PARAM_OFFSET_LIMIT,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function processReindex ({ storeKey }) {
  return {
    type: PROCESS_REINDEX,
    payload: { storeKey },
  }
}
